export default __webpack_public_path__ + "static/media/s1-icon-3.1638256b.svg";